module.exports = coreApis.componentApis.component;